import styles from './listingCard.module.css';

import { ReactComponent as Star } from '../../../assets/icons/trvto_star.svg';
import { getHikedPrice } from '../../../utils/getAmountWithTransaction';
import { ReactComponent as Location } from '../../../assets/icons/trvto_location.svg';
import { ReactComponent as Calender } from '../../../assets/icons/trvto_calendar.svg';
import { ReactComponent as LoveBlack } from '../../../assets/icons/trvto_wishlist.svg';
import { ReactComponent as LoveRed } from '../../../assets/icons/trvto_favorite.svg';
import { ReactComponent as Users } from '../../../assets/icons/trvto_users.svg';
import { ReactComponent as Clock } from '../../../assets/icons/trvto_clock.svg';
import { ReactComponent as Difficulty } from '../../../assets/icons/trvto_difficulty.svg';
import { ReactComponent as RatingStar } from '../../../assets/icons/trvto_rating-star.svg';
import { ReactComponent as Delete } from '../../../assets/icons/trvto_deleteIcon.svg';
import { ReactComponent as Share } from '../../../assets/icons/trvto_share.svg';

import ReviewStars from '../../reviewStars/ReviewStars';
import { share } from '../../tripStrap/tripStrapFun/shareFun';

// Accommodation meal plans -> card text
const MEAL_LABELS = {
    breakfast: 'Breakfast included',
    half_board: 'Breakfast & dinner included',
    full_board: 'All meals included',
    all_meals: 'All meals included'
};

// grey placeholder for a card whose photo can't load
const NO_PHOTO = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='4' height='3'%3E%3Crect width='4' height='3' fill='%23e5e7eb'/%3E%3C/svg%3E";

const ListingCard = ({
    type,

    images,
    title,
    location,
    rating,

    duration,
    difficulty,
    daysAndNight,

    organizerName,

    finalDisplayPrice,
    group,
    firstDate,
    datesType,

    where,

    isFavorite,
    onTripCardClick,
    onWishListClick,

    _id,

    actualPrice,

    myWishList = false,
    handleDelete,
    interested,

    // =========================
    // CAMP DATA
    // =========================
    checkin,
    checkout,
    guests,
    propertyType,
    propertyCategory,
    priceUnit,
    strikePrice,
    discountPercent,

    // availability for the searched dates (camp search results)
    unitName,
    roomsNeeded,
    unitsLeft,
    fewLeft,
    mealPlan,
    refundable,
    // =========================
    // ACTIVITY / GUIDE DATA
    // =========================
    place,
    languages = [],
    timings,
    category,
    availability,
    reviewCount = 0
}) => {
    const isMobile = window.innerWidth < 768;

    const isCamp = type === 'camp';
    // activity / guide: place + duration are on the photo, so the rows below show other things
    const isSlotType = type === 'act' || type === 'gu';
    // guide: languages; activity: timings (whichever this listing has)
    const extraInfo =
        type === 'gu' && languages.length
            ? { label: 'Languages', value: languages.join(', ') }
            : timings
              ? { label: 'Timings', value: timings }
              : null;

    // "Bengaluru, Mysuru/Mysore" -> ['Bengaluru', 'Mysuru/Mysore']
    const startCities = (Array.isArray(location) ? location : String(location || '').split(','))
        .map((city) => String(city).trim())
        .filter(Boolean);

    /* =====================================================
       CAMP DATA HELPERS
    ===================================================== */

    const campPropertyType = propertyType || propertyCategory || 'Stay';

    const campLocation = location || where || 'Location';

    const campGuests = guests || 1;

    const campPrice = actualPrice || finalDisplayPrice || 0;

    const campStrikePrice = strikePrice || getHikedPrice(campPrice);

    const campMeal = MEAL_LABELS[mealPlan] || '';

    const campDiscount =
        discountPercent ||
        (campStrikePrice > campPrice ? Math.round(((campStrikePrice - campPrice) / campStrikePrice) * 100) : 0);

    /* =====================================================
       CLICK
    ===================================================== */

    const handleCardClick = () => {
        if (onTripCardClick) {
            onTripCardClick(_id);
        }
    };

    return (
        <div
            className={`${styles.container} ${isSlotType ? styles.slotCard : ''} ${interested ? styles.interestedTrip : ''}`}
            onClick={handleCardClick}
        >
            <div className={styles.card}>
                {/* =================================================
                   IMAGE
                ================================================= */}

                <div className={styles.cardImage}>
                    <img
                        src={images?.[0]}
                        alt={title || 'Card Images'}
                        onError={(e) => {
                            // broken / missing photo: plain grey box instead of the alt text
                            e.currentTarget.onerror = null;
                            e.currentTarget.src = NO_PHOTO;
                        }}
                    />
                </div>

                {/* =================================================
                   WISHLIST / SHARE / DELETE
                ================================================= */}

                {myWishList ? (
                    <>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                share(e, _id, type, title);
                            }}
                            className={styles.shareButton}
                        >
                            <Share />
                        </button>

                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDelete(_id);
                            }}
                            className={styles.wishlistButton}
                        >
                            <Delete />
                        </button>
                    </>
                ) : (
                    <button
                        className={styles.wishlistButton}
                        onClick={(event) => {
                            event.stopPropagation();

                            onWishListClick(_id);
                        }}
                    >
                        {isFavorite ? (
                            <LoveRed className={styles.wishlistIcon} />
                        ) : (
                            <LoveBlack className={styles.wishlistIcon} />
                        )}
                    </button>
                )}

                {/* =================================================
                   IMAGE LOCATION
                ================================================= */}

                <p className={styles.imgCardlocation}>
                    <Location className={styles.locationIconWhere} />

                    <span>{isCamp ? campLocation : where}</span>
                </p>

                {/* =================================================
                   IMAGE TOP RIGHT INFO
                ================================================= */}

                <p className={styles.imgCardDuration}>{isCamp ? campPropertyType : duration}</p>

                {/* activity / guide category, top-left of the photo */}
                {isSlotType && category && <p className={styles.imgCardType}>{category}</p>}

                {/* =================================================
                   CARD CONTENT
                ================================================= */}

                <div className={styles.cardContent}>
                    {/* =================================================
                       TITLE
                    ================================================= */}

                    <p className={styles.cardTitle}>{title}</p>

                    <div className={styles.cardRatingAndDays}></div>

                    {/* =================================================
                       MAIN INFORMATION
                    ================================================= */}

                    <div className={styles.cardDatesTypeContentContainer}>
                        <div className={styles.cardNameAndLocation}>
                            {/* =================================================
                               ORGANIZER
                            ================================================= */}

                            {!isCamp && organizerName && (
                                <div className={isMobile ? styles.cardNameAndLocatio : styles.cardNameAndLocation1}>
                                    <div className={styles.cardNameContainer}>
                                        <span className={styles.cardDays}>By</span>

                                        <p className={styles.cardRating}>{organizerName}</p>
                                    </div>
                                </div>
                            )}

                            {/* =================================================
                               TRIP
                            ================================================= */}

                            {!isCamp && (
                                <>
                                    {!isSlotType && (
                                    <div className={isMobile ? styles.cardNameAndLocatio : styles.cardNameAndLocation1}>
                                        <div
                                            className={`${styles.cardNameContainer} ${styles.locationFrom} ${styles.fullRow}`}
                                        >
                                            <Location className={styles.cardLocationIconWhere} />

                                            <span className={styles.cardDays}>From</span>

                                            {/* first start city + how many more (full list on hover) */}
                                            <p className={styles.cardRating} title={startCities.join(', ')}>
                                                {startCities[0]}
                                                {startCities.length > 1 && (
                                                    <span className={styles.moreCities}> +{startCities.length - 1}</span>
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                    )}

                                    {type === 'trip' ? (
                                        <div className={`${styles.cardNameAndLocation1} ${styles.cardMetaRow}`}>
                                            <div className={styles.cardNameContainer}>
                                                <Calender
                                                    width={15}
                                                    height={15}
                                                    className={styles.cardLocationIconWhere}
                                                />

                                                <span className={styles.cardDays}>Dates</span>

                                                <p className={styles.cardRating}>{datesType}</p>
                                            </div>

                                            <div className={styles.cardNameContainer}>
                                                <Users
                                                    width={15}
                                                    height={15}
                                                    className={styles.cardLocationIconWhere}
                                                />

                                                <span className={styles.cardDays}>Group</span>

                                                <p className={styles.cardRating}>{group}</p>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className={`${styles.cardNameAndLocation1} ${styles.cardMetaRow}`}>
                                            {/* activity / guide: duration is on the photo -> Difficulty gets the whole line */}
                                            {!isSlotType && (
                                                <div className={styles.cardNameContainer}>
                                                    <Clock width={15} height={15} className={styles.cardLocationIconWhere} />

                                                    <span className={styles.cardDays}>Duration</span>

                                                    <p className={styles.cardRating}>{duration}</p>
                                                </div>
                                            )}

                                            <div className={`${styles.cardLocationContainer} ${isSlotType ? styles.fullRow : ''}`}>
                                                <Difficulty
                                                    width={15}
                                                    height={15}
                                                    className={styles.cardLocationIconWhere}
                                                />

                                                <span className={styles.cardDays}>Difficulty</span>

                                                <p className={styles.cardRating}>{difficulty}</p>
                                            </div>
                                        </div>
                                    )}

                                    {isSlotType && extraInfo && (
                                        <div className={`${styles.cardNameAndLocation1} ${styles.cardMetaRow}`}>
                                            <div className={`${styles.cardNameContainer} ${styles.fullRow}`}>
                                                <Clock width={15} height={15} className={styles.cardLocationIconWhere} />
                                                <span className={styles.cardDays}>{extraInfo.label}</span>
                                                <p className={styles.cardRating} title={extraInfo.value}>
                                                    {extraInfo.value}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </>
                            )}

                            {/* =================================================
                               CAMP
                            ================================================= */}

                            {isCamp && (
                                <>
                                    {/* LOCATION */}

                                    <div className={styles.cardNameAndLocation1}>
                                        <div className={`${styles.cardNameContainer} ${styles.locationFrom}`}>
                                            <Location className={styles.cardLocationIconWhere} />

                                            <span className={styles.cardDays}>Location</span>

                                            <p className={styles.cardRating}>{campLocation}</p>
                                        </div>
                                    </div>

                                    {/* PROPERTY TYPE + GUESTS */}

                                    <div className={styles.cardNameAndLocation1}>
                                        <div className={styles.cardNameContainer}>
                                            <Clock width={15} height={15} className={styles.cardLocationIconWhere} />

                                            <span className={styles.cardDays}>Stay</span>

                                            <p className={styles.cardRating}>{campPropertyType}</p>
                                        </div>

                                        <div className={styles.cardNameContainer}>
                                            <Users width={15} height={15} className={styles.cardLocationIconWhere} />

                                            <span className={styles.cardDays}>Guests</span>

                                            <p className={styles.cardRating}>{campGuests}</p>
                                        </div>
                                    </div>

                                    {/* ROOM / TENT FREE FOR THE SEARCHED DATES */}

                                    {unitName && (
                                        <div className={styles.campUnit}>
                                            <span className={styles.campUnitName}>
                                                {roomsNeeded > 1 ? `${roomsNeeded} × ` : ''}
                                                {unitName}
                                            </span>

                                            {fewLeft && unitsLeft > 0 && (
                                                <span className={styles.campLeft}>Only {unitsLeft} left</span>
                                            )}
                                        </div>
                                    )}

                                    {(campMeal || refundable) && (
                                        <div className={styles.campPerks}>
                                            {campMeal && <span>✓ {campMeal}</span>}
                                            {refundable && <span>✓ Refundable</span>}
                                        </div>
                                    )}
                                </>
                            )}

                            {/* =================================================
                               DATE + RATING
                            ================================================= */}

                            <div className={styles.cardNameAndLocation2}>
                                {/* =============================================
                                   TRIP FIXED DATE
                                ============================================= */}

                                {type === 'trip' && datesType === 'fixed' && !myWishList && (
                                    <div className='tripCardLocation dateView'>
                                        <Calender className={styles.cardLocationIconWhere} />

                                        <div className='innerDateContent'>
                                            {firstDate}

                                            <span>Onwards</span>
                                        </div>
                                    </div>
                                )}

                                {/* =============================================
                                   CAMP CHECK IN / OUT
                                ============================================= */}

                                {isCamp && (
                                    <div className='tripCardLocation dateView'>
                                        <Calender className={styles.cardLocationIconWhere} />

                                        <div className='innerDateContent'>
                                            {checkin || '--'}

                                            <span>Check-in</span>
                                        </div>
                                    </div>
                                )}

                                {/* =============================================
                                   RATING
                                ============================================= */}

                                <span
                                    className='tripRatings'
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '5px'
                                    }}
                                >
                                    {isMobile ? (
                                        <RatingStar className={styles.cardLocationIconWhere} />
                                    ) : (
                                        <ReviewStars rating={rating || 0} />
                                    )}

                                    <span className={styles.ratingCount}>{rating || 0}</span>
                                    {reviewCount > 0 && <span className={styles.reviewCount}>({reviewCount})</span>}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* =================================================
                       PRICE
                    ================================================= */}

                    <div className={styles.priceContainer}>
                        <div className={styles.priceLeft}>
                            <div className={styles.priceActualPrice}>₹{campPrice}</div>

                            <div className={styles.perPerson}>{isCamp ? 'Per Night' : 'Per Person'}</div>
                        </div>

                        <div className={styles.priceDivider} />

                        <div className={styles.priceRight}>
                            <div className={styles.priceHikedPrice}>₹{campStrikePrice}</div>

                            {campDiscount > 0 && <div className={styles.discountBadge}>{campDiscount}% OFF</div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListingCard;
